module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages-virtual-orthodontic-consultation"
  }, [_c('div', {
    staticClass: "pages-virtual-orthodontic-consultation__container"
  }, [_c('div', {
    staticClass: "pages-virtual-orthodontic-consultation__title"
  }, [_vm._v("Request a Virtual Orthodontic Consultation")]), _c('div', {
    staticClass: "pages-virtual-orthodontic-consultation__content"
  }, [_vm._v("Thank you for your interest in a Virtual Orthodontic Consultation. Please fill out the form below to reserve your spot. After submitting the form, we will ask you to send us some photos. Please watch the video below to learn how to send us some photos of your smile so that we can determine what type of treatment is best for you. "), _c('br'), _c('br'), _c('div', {
    staticClass: "pages-virtual-orthodontic-consultation__video-ctnr"
  }, [_c('video', {
    ref: "video",
    staticClass: "pages-virtual-orthodontic-consultation__video",
    attrs: {
      "src": _vm.props.videoUrl,
      "type": "video/mp4",
      "controls": "controls",
      "controlsList": "nodownload"
    }
  }, [_vm._v("Your browser doesn't support HTML5 video. ")])])]), _vm._m(0), _c('VirtualForm')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages-virtual-orthodontic-consultation__content"
  }, [_vm._v(" After submitting this form and sending your photos, one of our team members will contact you as soon as possible to schedule a time that is convenient for you to speak about treatment."), _c('br'), _c('br'), _vm._v("**IMPORTANT: In the \"Message\" field below, please include your insurance information, including:"), _c('ol', [_c('li', [_vm._v("Primary Insurance Name")]), _c('li', [_vm._v("Policy Holder/ Subscribers Name")]), _c('li', [_vm._v("Date of Birth")]), _c('li', [_vm._v("SS#")]), _c('li', [_vm._v("ID#")]), _c('li', [_vm._v("Group#")])]), _c('br')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-81ca324c","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/pages/virtual-orthodontic-consultation/virtual-orthodontic-consultation.pug
// module id = 714
// module chunks = 1